export const QUERY_KEYS = {
  cartItems: 'cartItems',
  cartCount: 'cartCount',
  localStorageCart: 'localStorageCart',
  localStorageCartCount: 'localStorageCartCount',
  masterclasses: 'masterclasses',
  masterclass: 'masterclass',
  purchases: 'purchases',
  profile: 'profile',
  favorites: 'favorites',
  removeMasterclassFromCart: 'removeMasterclassFromCart',
  favoritesCount: 'favoritesCount',
  localStorageFavorites: 'localStorageFavorites',
  localStorageFavoritesCount: 'localStorageFavoritesCount',
  myReviews: 'myReviews',
  myReviewsCount: 'myReviewsCount',
  settings: 'settings',
  categories: 'categories',
  purchasesCount: 'purchasesCount',
  top5: 'top5',
  analytics: 'analytics',
} as const;
